import PropTypes from 'prop-types';
import { Box, Divider, Drawer, Link, Stack, Typography, useMediaQuery } from '@mui/material';
import { Logo } from 'components/Logo';
import { Scrollbar } from 'components/Scrollbar';
import { items } from './config';
import { SideNavItem } from './SideNavItem';
import { useLocation } from 'react-router';

export const SideNav = (props) => {
  const { open, onClose } = props;
  //@ts-expect-error: MUI type error
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const { pathname } = useLocation();

  const content = (
    <Scrollbar
      sx={{
        height: '100%',
        overflow: 'hidden',
        '& .simplebar-content': {
          height: '100%',
        },
        '& .simplebar-scrollbar:before': {
          background: 'neutral.400',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box
            sx={{
              display: 'inline-flex',
              height: 32,
              width: 42,
            }}
          >
            <Link href='/' underline='hover' variant='subtitle2'>
              <Logo />
            </Link>
          </Box>
          <Box
            sx={{
              alignItems: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              borderRadius: 1,
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              mt: 2,
              p: '12px',
            }}
          >
            <div>
              <Typography color='inherit' variant='subtitle1'>
                Blucloud
              </Typography>
              <Typography color='neutral.400' variant='body2'>
                Sensing Simply
              </Typography>
            </div>
          </Box>
        </Box>
        <Divider sx={{ borderColor: 'neutral.700' }} />
        <Box
          component='nav'
          sx={{
            flexGrow: 1,
            px: 2,
            py: 3,
          }}
        >
          <Stack
            component='ul'
            spacing={0.5}
            sx={{
              listStyle: 'none',
              p: 0,
              m: 0,
            }}
          >
            {items.map((item) => {
              return (
                <SideNavItem
                  active={item.path === pathname}
                  icon={item.icon}
                  key={item.title}
                  path={item.path}
                  title={item.title}
                  badge={item.badge}
                />
              );
            })}
          </Stack>
        </Box>
      </Box>
    </Scrollbar>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor='left'
        open
        PaperProps={{
          sx: {
            backgroundColor: 'neutral.800',
            color: 'common.white',
            width: 280,
          },
        }}
        variant='permanent'
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor='left'
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: 'neutral.800',
          color: 'common.white',
          width: 280,
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant='temporary'
    >
      {content}
    </Drawer>
  );
};

SideNav.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
